import React, { useState, useEffect } from "react";

// React Icons
import {
    FaBuilding,
    FaMapMarkerAlt,
    FaClock,
    FaCalendarAlt,
    FaLink,
} from "react-icons/fa";

const JobDetail = ({ job, onStatusChange, onClose }) => {
    const [status, setStatus] = useState(job.status || "bookmarked");

    useEffect(() => {
        setStatus(job.status || "bookmarked");
    }, [job]);

    const handleStatusChange = (newStatus) => {
        setStatus(newStatus);
        if (onStatusChange) {
            onStatusChange(job.id, newStatus);
        }
    };

    const getStatusClass = (status) => {
        switch (status) {
            case "bookmarked":
                return "bg-gray-100 text-gray-800";
            case "applied":
                return "bg-blue-100 text-blue-800";
            case "interview":
                return "bg-purple-100 text-purple-800";
            case "offer":
                return "bg-green-100 text-green-800";
            case "no responses":
                return "bg-yellow-100 text-yellow-800";
            case "rejected":
                return "bg-red-100 text-red-800";
            default:
                return "bg-gray-100 text-gray-800";
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                <div className="flex justify-between items-start mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                        {job.title}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700"
                    >
                        ✕
                    </button>
                </div>

                <div className="space-y-4">
                    <div className="flex items-center text-gray-600">
                        <FaBuilding className="mr-2" />
                        <span>{job.company}</span>
                    </div>

                    <div className="flex items-center text-gray-600">
                        <FaMapMarkerAlt className="mr-2" />
                        <span>
                            {job.location} ({job.continent})
                        </span>
                    </div>

                    <div className="flex items-center text-gray-600">
                        <FaClock className="mr-2" />
                        <span>{job.fulltime_parttime}</span>
                    </div>

                    <div className="flex items-center text-gray-600">
                        <FaCalendarAlt className="mr-2" />
                        <span>Experience: {job.experience}</span>
                    </div>

                    <div className="flex items-center text-gray-600">
                        <FaLink className="mr-2" />
                        <a
                            href={job.application_url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800"
                        >
                            Application Link
                        </a>
                    </div>

                    {job.deadline && (
                        <div className="flex items-center text-gray-600">
                            <FaCalendarAlt className="mr-2" />
                            <span>Deadline: {job.deadline}</span>
                        </div>
                    )}

                    <div className="mt-6">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Application Status
                        </label>
                        <select
                            className={`w-full p-2 rounded-md border ${getStatusClass(
                                status
                            )}`}
                            value={status}
                            onChange={(e) => handleStatusChange(e.target.value)}
                        >
                            <option value="bookmarked">Bookmarked</option>
                            <option value="applied">Applied</option>
                            <option value="interview">Interview</option>
                            <option value="offer">Offer</option>
                            <option value="no responses">No Responses</option>
                            <option value="rejected">Rejected</option>
                        </select>
                    </div>

                    {job.admin_notes && (
                        <div className="mt-6">
                            <h3 className="text-lg font-medium text-gray-800 mb-2">
                                Admin Notes
                            </h3>
                            <p className="text-gray-600">{job.admin_notes}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default JobDetail;
